import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import Payouts from './Payouts';
import RateCardCreate from './RateCards/Create';
import RateCardDetails from './RateCards/Details';
import RateCardList from './RateCards/List';
import ParkingLotList from './ParkingLots/List';
import SanctionedPlates from './SanctionedPlates';
import UserCreate from './Users/Create';
import UserDetails from './Users/Details';
import UserList from './Users/List';
import SanctionedTimesOnlyList from "./SanctionedOnlyTimes/List";
import SanctionedTimeCreate from "./SanctionedOnlyTimes/Create";
import SanctionedTimeUpdate from "./SanctionedOnlyTimes/Details";
import AddOrEditHourlyRates from "./RateCards/HourlyRates/AddOrEditHourlyRates";
import ParkingLotCreate from "./ParkingLots/Create";
import ParkingLotDetails from "./ParkingLots/Details";
import DefaultLotDetails from "./ParkingLots/DefaultDetails";
import PayoutDetails from "./Payouts/PayoutDetails";
import RoleList from "./Roles/List";
import RoleDetails from "./Roles/Details";
import {PERMISSIONS} from "../../lib/authManager";
import {PermissionRoute} from "../../components/AdminOnly";

export default function Settings({ match }) {
	return (
		<Switch>
			<PermissionRoute
				exact
				path={`${match.path}/guestcards`}
				component={RateCardList}
				permissions={[PERMISSIONS.GUEST_CARDS_READ, PERMISSIONS.GUEST_CARDS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/guestcards/new`}
				component={RateCardCreate}
				permissions={PERMISSIONS.GUEST_CARDS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/guestcards/hourly-rates`}
				component={AddOrEditHourlyRates}
				permissions={PERMISSIONS.GUEST_CARDS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/guestcards/:rateCardId`}
				component={RateCardDetails}
				permissions={[PERMISSIONS.GUEST_CARDS_READ, PERMISSIONS.GUEST_CARDS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/lots`}
				component={ParkingLotList}
				permissions={[PERMISSIONS.PARKING_LOTS_READ, PERMISSIONS.PARKING_LOTS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/lots/new`}
				component={ParkingLotCreate}
				permissions={PERMISSIONS.PARKING_LOTS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/lots/default`}
				component={DefaultLotDetails}
				permissions={[PERMISSIONS.PARKING_LOTS_READ, PERMISSIONS.PARKING_LOTS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/lots/:lotId`}
				component={ParkingLotDetails}
				permissions={[PERMISSIONS.PARKING_LOTS_READ, PERMISSIONS.PARKING_LOTS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/payouts/:id`}
				component={PayoutDetails}
				permissions={[PERMISSIONS.PAYOUTS_READ, PERMISSIONS.PAYOUTS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/payouts`}
				component={Payouts}
				permissions={[PERMISSIONS.PAYOUTS_READ, PERMISSIONS.PAYOUTS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/users`}
				component={UserList}
				permissions={[PERMISSIONS.USERS_READ, PERMISSIONS.USERS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/users/new`}
				component={UserCreate}
				permissions={PERMISSIONS.USERS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/roles`}
				component={RoleList}
				permissions={PERMISSIONS.USERS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/roles/:roleId?`}
				component={RoleDetails}
				permissions={PERMISSIONS.USERS_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/users/:userId`}
				component={UserDetails}
				permissions={[PERMISSIONS.USERS_READ, PERMISSIONS.USERS_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/plates`}
				component={SanctionedPlates}
				permissions={[PERMISSIONS.SANCTIONED_PLATES_READ, PERMISSIONS.SANCTIONED_PLATES_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/sanctioned`}
				component={SanctionedTimesOnlyList}
				permissions={[PERMISSIONS.SANCTIONED_TIMES_READ, PERMISSIONS.SANCTIONED_TIMES_MANAGE]}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/sanctioned/new`}
				component={SanctionedTimeCreate}
				permissions={PERMISSIONS.SANCTIONED_TIMES_MANAGE}
			/>

			<PermissionRoute
				exact
				path={`${match.path}/sanctioned/:id`}
				component={SanctionedTimeUpdate}
				permissions={[PERMISSIONS.SANCTIONED_TIMES_READ, PERMISSIONS.SANCTIONED_TIMES_MANAGE]}
			/>

			<Redirect to={`/${match.params.brandingKey}/profile`} />
		</Switch>
	);
}
